module.exports = __webpack_public_path__ + "static/media/chevrons-up.a67e05bd.svg";